var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParchment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5.0625C0.5 4.14844 1.23828 3.375 2.1875 3.375C3.10156 3.375 3.875 4.14844 3.875 5.0625V7.875H2.1875H1.625C0.992188 7.875 0.5 7.38281 0.5 6.75V5.0625ZM4.4375 3.375H14C15.8633 3.375 17.375 4.88672 17.375 6.75V13.5H11.5391C10.4141 13.5 9.5 14.4492 9.5 15.5742V15.75C9.5 17.0156 8.48047 18 7.25 18C5.98438 18 5 17.0156 5 15.75V5.0625C5 4.42969 4.78906 3.86719 4.4375 3.375ZM16.8125 19.125H13.4375H7.25C9.11328 19.125 10.625 17.6133 10.625 15.75V15.5742C10.625 15.0469 11.0469 14.625 11.5391 14.625H20.1875C20.4688 14.625 20.75 14.9062 20.75 15.1875C20.75 17.3672 18.957 19.125 16.8125 19.125Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParchment);
export default ForwardRef;